import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
